import { TourneeEtablissement } from "./TourneeEtablissement";

export class Tournee {
    id: number = 0;
    date: Date = new Date();
    tourneeEtablissements: TourneeEtablissement[] = new Array();
    archiver: boolean = false;
    nom: string = ""
}